import React, { Component } from 'react'
import { Header } from 'semantic-ui-react'
import RowItem from '@ui/RowItem'
import Section from '@ui/Section'
import Button from './Button'

export default class Counter extends Component {
  state = {
    value: this.props.value
  }

  componentDidUpdate(prevProps) {
    const { value } = this.props
    if (prevProps.value !== value) this.setState({ value })
  }

  handleEdit = ({ title }) => {
    const { onEdit, name } = this.props
    onEdit({ id: name, text: title })
  }

  handleChange = value => {
    const { name, onChange } = this.props
    this.setState({ value })
    onChange(name, value)
  }

  handleLess = () => this.handleChange(this.state.value - 1)

  handleMore = () => this.handleChange(this.state.value + 1)

  render() {
    const { text, name, min, max, editable, inactive, onRemove, variablesOptions } =
      this.props
    const { value } = this.state

    return (
      <RowItem id={name} onRemove={onRemove} editable={editable} className='no-wrap'>
        <Section
          size='h3'
          titleEditable={editable}
          title={text}
          onBlur={this.handleEdit}
          variablesOptions={variablesOptions}
          titleRequired
          hideDescription
          horizontal
        />
        <Button
          onClick={this.handleLess}
          disabled={value === min}
          icon='minus'
          inactive={inactive}
        />
        <Header as='h3' className='counter-input-header'>
          {value}
        </Header>
        <Button
          onClick={this.handleMore}
          disabled={max ? value === max : false}
          icon='plus'
          inactive={inactive}
        />
      </RowItem>
    )
  }
}
